import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

// JS Files

// Others File

const LinksCard = (props) => {
  return (
    <>
      <a href={props.route} target="_blank">
        <div className="mt-4 bg-white rounded-lg cursor-pointer py-2 px-4 flex justify-between items-center">
          <div className="flex items-center">
            <img
              className="rounded-full p-4 bg-myorange-200"
              src={props.icon}
            />
            <span className="text-sm md:taxt-base mr-8 text-black">
              {props.header}
            </span>
          </div>
          <ArrowBackIosIcon className="text-myorange-500" />
        </div>
      </a>
    </>
  );
};
export default LinksCard;
